'use client';
import { DefaultCallNumber } from '@/data/globals.data';
import { ContactPlacement, PLACEMENT_ATTRIBUTE } from '@/lib/analytics';
import { useModalStore } from '@/store/modal.store';
import { useSidebarStore } from '@/store/sidebar.store';
import { usePathname } from 'next/navigation';
import React from 'react';
import ConsultationForm from './consultation-form';
import ImageOptimizer from './image-optimizer';
import MobileSidebar from './mobile-sidebar';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const { isOpen, open: openModal } = useModalStore();
  const { isOpen: isSidebarOpen, close: closeSidebar } = useSidebarStore();

  const pathname = usePathname();
  // /branch/[branchSlug], /recommend-class 경로에서 안 보이도록 설정
  const showMobileFloating =
    !pathname?.startsWith('/branch/') &&
    !pathname?.startsWith('/recommend-class');

  return (
    <div className="desktop:max-w-screen mobile-w relative mx-auto box-border w-full overflow-hidden bg-white">
      <MobileSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      {children}
      {isOpen && <ConsultationForm />}

      {showMobileFloating && (
        <div
          {...{ [PLACEMENT_ATTRIBUTE]: ContactPlacement.MOBILE_FLOATING }}
          className="desktop:hidden mobile-w pointer-events-none fixed bottom-0 w-full"
        >
          <div className="mobile-w pointer-events-none inline-flex w-full flex-col items-end pr-6 pb-6">
            <a
              href={`tel:${DefaultCallNumber}`}
              className="pointer-events-auto"
            >
              <ImageOptimizer
                src="/images/main/floating_call_btn.png"
                alt="전화상담 버튼"
                width="56"
                height="56"
              />
            </a>
            <a
              href="https://pf.kakao.com/_urbdG/chat"
              target="_blank"
              rel="noopener noreferrer"
              className="pointer-events-auto"
            >
              <ImageOptimizer
                src="/images/main/floating_kakao_btn.png"
                alt="카카오 버튼"
                width="56"
                height="56"
              />
            </a>

            <button
              onClick={() => openModal()}
              className="pointer-events-auto cursor-pointer"
            >
              <ImageOptimizer
                src="/images/main/floating_reserve_btn.png"
                alt="상담예약 버튼"
                width="147"
                height="56"
              />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainLayout;
